import { Address, AddressComponent, Country, Language,
  LocalizedString, getLanguageOfCountry, isNullOrUndefined,
  toEnumFromStringOrNull } from 'in-time-core';
import { logError, logWarning } from 'in-time-logger';

export interface BillingAddressDetails {
  country: string | null,
  postalCode: string | null,
  county: string | null,
  city: string | null,
  address: string | null,
}

export function createAddressFromBillingDetails(details: BillingAddressDetails | null): Address | null {
  if(isNullOrUndefined(details)) {
    logWarning('Billing details were not provided when trying to sign up.');
    return null;
  }

  if(isNullOrUndefined(details.country) ||
      isNullOrUndefined(details.postalCode) ||
      isNullOrUndefined(details.county) ||
      isNullOrUndefined(details.city) ||
      isNullOrUndefined(details.address)) {
    logError(`Billing details were incomplete when trying to sign up: ${JSON.stringify(details)}`);
    return null;
  }

  const country = toEnumFromStringOrNull(details.country, Country);
  const language = country == null ? Language.English : (getLanguageOfCountry(country) ?? Language.English);

  return Address.create({
    country: details.country,
    administrativeAreaLevel1: AddressComponent.fromName(details.county, language),
    locality: AddressComponent.fromName(details.city, language),
    postalCode: details.postalCode,
    formattedAddresses: LocalizedString.forLanguage(language, details.address),
  });
}
